<template>
  <div id="produtos-comissao-especial" class="w3-container w3-margin-top" style="padding: 0;">
    
    <div class="w3-col s12 m12 l12" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>
    
    <div v-if="!processando" class="w3-margin-bottom">
      <input 
        type="text"
        v-model="filtro_produtos"
        v-on:keyup="filtrarProdutos()"
        placeholder="Pesquise por código ou nome do produto"
        class="w3-input w3-border w3-padding margin-bottom-filtro">
      
      <label>Empresa</label>
      <select 
        @click="mudarPagina(0)"
        v-model="empresa_selecionada_id"
        class="w3-input w3-border margin-bottom-filtro" 
        @change="buscarProdutosComissaoEspecial()">
        <option 
          v-for="empresa in empresas_autorizadas" 
          :value="empresa.empresa_id"
          :key="empresa.empresa_id">
          {{`${empresa.empresa_id} - ${empresa.nome_fantasia}`}}
        </option>
      </select> 

      <label>Marca</label>
      <select 
        v-model="filtro_marca"
        @click="filtrarMarca()"
        class="w3-select w3-input w3-border margin-bottom-filtro">
        <option value="">Selecione uma marca</option>
        <option 
          v-for="(marca, index) in marcas"
          :key="index" 
          :value="marca.marca">
          {{marca.marca}}
        </option>
      </select> 
    </div>
 
    <div 
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="(
        (Object.keys(produtos_filtrados).length === 0) &&
        !processando &&
        !processando_produtos
      )"
      v-cloak>
      
      <div class="w3-container w3-white">
        <p>Não há produtos a serem exibidos.</p>
      </div>
    </div>
    
    <div
      class="wrapper-componente"
      v-if="(Object.keys(produtos_filtrados).length > 0) && !processando">
      
      <div 
        class="card-item w3-container"
        v-for="(produto, index) in novosProdutosFiltrados" 
        :key="index">
        
        <div class="w3-col s12">
          <strong class="w3-text-theme"><i class="fas fa-box"></i>&nbsp;{{produto.produto_id}} - {{produto.nome}} - {{produto.unidade}}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Marca: </label>
          <strong>{{ produto.marca }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Comissão Especial: </label>
          <strong>{{ produto.perc_comissao_esp }}%</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Duração: </label>
          <strong>{{ produto.data_inicio_com_esp }} - {{ produto.data_final_com_esp }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Quantidade Dias para Término: </label>
          <strong>{{ produto.qtd_dias_termino_com_esp }}</strong>
        </div>
        
        <div class="w3-col s12">
          <label>Preço Venda: </label>
          <strong>R$ {{ produto.preco_venda }}</strong>
        </div>
      
      </div>
      <paginacao
        @pagina="mudarPagina"
        :pagina-atual="paginaAtual"
        :itens-por-pagina="itensPorPagina"
        :total-resultados="totalResultados"
        :total-de-paginas="totalDePaginas" />
    </div>
    
    <div
      class="w3-col s12 m12 l12 w3-margin-bottom"
      v-if="processando_produtos && !processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '@/ambiente/store';
  import Paginacao from '@/components/Paginacao'
  import RSessao from '@/components/Rest/RSessao'
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import REmpresa from '@/components/Rest/REmpresa'
  import RProdutoBuscarProdutosComissaoEspecialDashboard from '@/components/Rest/RProduto/RProdutoBuscarProdutosComissaoEspecialDashboard'

  export default {
    name: 'ProdutosComissaoEspecial',
    components: {
      Paginacao
    },
    data() {
      return {
        api: process.env.API,
        produtos_cadastrados_filtrados: [],
        qtd_produtos_comissao_especial: 0,
        processando: false,
        processando_produtos: false,
        filtro_produtos: '',
        filtro_marca: '',
        empresa_selecionada_id: 0,
        produtos_filtrados: [],

        empresas_autorizadas: [],
        nome_empresa: '',

        paginaAtual: 0,
        itensPorPagina: 10,
        totalResultados: 0,
        totalDePaginas: 0
      }
    },
    methods: {
      mudarPagina(numeroDaPagina) {
        this.paginaAtual = numeroDaPagina;
      },

      filtrarMarca(){
        if (!this.produtos_cadastrados_filtrados){
          this.confirmarQtdProdutoComissaoEspecial(0);
          return;
        }

        if (!this.filtro_marca){
          this.produtos_filtrados = JSON.parse(JSON.stringify(this.produtos_cadastrados_filtrados));
          this.confirmarQtdProdutoComissaoEspecial(this.produtos_filtrados.length);
          return;
        }

        this.produtos_filtrados = [];
        for (let i = 0; i < this.produtos_cadastrados_filtrados.length; i++) {
          if (this.filtro_marca == this.produtos_cadastrados_filtrados[i].marca){
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
          }
        }

        this.confirmarQtdProdutoComissaoEspecial(this.produtos_filtrados.length);
      },

      filtrarProdutos() {
        this.produtos_filtrados = [];
        this.mudarPagina(0);

        if(this.filtro_produtos == '') {
          this.produtos_filtrados = this.produtos_cadastrados_filtrados;
          return;
        }
        
        this.filtro_produtos = this.filtro_produtos.toUpperCase();
        for (var i = 0; i < this.produtos_cadastrados_filtrados.length; i++) {
          if (this.produtos_cadastrados_filtrados[i].nome.toUpperCase().indexOf(this.filtro_produtos) > -1){
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
          }

          if (this.produtos_cadastrados_filtrados[i].produto_id.replace(".", "").indexOf(this.filtro_produtos) > -1){
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
          }
        }
      },
      
      limparResultados(){
        this.paginaAtual = 0;
        this.itensPorPagina = 10;
        this.totalResultados = 0;
        this.totalDePaginas = 0;
        this.produtos_filtrados = [];
        this.produtos_cadastrados_filtrados = [];
        this.confirmarQtdProdutoComissaoEspecial(0);
      },

      async buscarQuantidadeTotalProdutosComissaoEspecial(){       
        this.confirmarQtdProdutoComissaoEspecial(this.qtd_produtos_comissao_especial);  
      },

      confirmarQtdProdutoComissaoEspecial(qtd_produtos){
        this.$emit(
          'quantidade_produto_comissao_especial', 
          {quant_produto: qtd_produtos}
        );
      },
      
      async buscarProdutosComissaoEspecial() {
        try {
          this.limparResultados();
          this.processando_produtos = true;

          let parametros = {
            empresa_id: this.empresa_selecionada_id
          }

          let retorno = await RProdutoBuscarProdutosComissaoEspecialDashboard.buscarProdutosComissaoEspecialDashboard(
            this.axios, 
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          if (retorno.dados) {
            this.produtos_filtrados = JSON.parse(JSON.stringify(retorno.dados));
            this.produtos_cadastrados_filtrados = JSON.parse(JSON.stringify(this.produtos_filtrados));
            this.confirmarQtdProdutoComissaoEspecial(this.produtos_cadastrados_filtrados.length);
          }

          this.processando = false;
          this.processando_produtos = false;
        }
        catch (error) {
          this.processando = false;
          this.processando_produtos = false;
          Biblioteca.exclamar(error.message);
        }
      },

      async buscarDadosCarregamento() {
        this.empresas_autorizadas = JSON.parse(JSON.stringify(await store.state.empresas_autorizadas));
        this.empresa_selecionada_id = await store.state.empresa_logada.empresa_id;
        await this.buscarProdutosComissaoEspecial();

        this.qtd_produtos_comissao_especial = 0;
        if (this.produtos_cadastrados_filtrados) {
          this.qtd_produtos_comissao_especial = this.produtos_cadastrados_filtrados.length;
        }
      }
    },

    computed: {
      marcas() {
        let produtos_lista_filtrada = this.produtos_cadastrados_filtrados;

        let marcas_filtradas = produtos_lista_filtrada.filter((thing, index, self) =>
          index === self.findIndex((marca) => (
            marca.marca === thing.marca
          ))
        )

        marcas_filtradas.sort((a, b) => {
          var textA = a.marca.toUpperCase();
          var textB = b.marca.toUpperCase();
          return (textA < textB) ? - 1 : (textA > textB) ? 1 : 0;
        })

        return marcas_filtradas
      },
      
      novosProdutosFiltrados() {
        this.totalResultados = this.produtos_filtrados.length;

        this.totalDePaginas =  Math.ceil(this.totalResultados / this.itensPorPagina);
        if(this.paginaAtual >= this.totalDePaginas) {
          this.paginaAtual = this.totalDePaginas;
        }
        var index = this.paginaAtual * this.itensPorPagina
        return this.produtos_filtrados.slice(index, index + this.itensPorPagina);
      }
    },

    mounted() {
      $('html,body').stop().animate(
        {
          scrollTop: 0
        }, 
        'slow', 
        'swing'
      );

      this.buscarDadosCarregamento();
    }
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  .wrapper-componente {
    overflow: auto
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ProdutosComissaoEspecial.vue